import moment from 'moment'

export interface Interval {
  from: string // format: 'H:m'
  to: string // format: 'H:m'
}

export interface DayAvailabilityConfig {
  day?: string
  type?: string // 'wday' or 'date'
  date?: string
  isActive?: boolean
  intervals?: Interval[]
}

/**
 * DayAvailability is a class that represents a day in the schedule
 * It can be a weekday or a specific_date
 * It can have multiple time slots
 * It can be active or inactive
 */
export class DayAvailability {
  intervals: Interval[] = []
  isActive = false
  day?: string
  date?: string
  type: string
  overlapIndex = 0

  constructor(config: DayAvailabilityConfig) {
    this.day = config.day
    this.type = config.type || 'wday'
    this.date = config?.date
    this.intervals = config.intervals || []
    this.isActive = Boolean(this.intervals.length > 0)
    this.setValidIntervals()
  }

  setValidIntervals() {
    this.intervals = this.intervals
      .filter(interval => {
        return interval.from && interval.to
      })
      .map(interval => {
        return {
          from: moment(interval.from, 'H:m').format('H:m'),
          to: moment(interval.to, 'H:m').format('H:m'),
        }
      })
  }
  addNewAvailabilityHourWithStartTimeAndEndTime(
    startTime: string,
    endTime: string
  ) {
    if ((!startTime && !endTime) || this.intervals.length === 0) {
      this.intervals.push({
        from: '8:0',
        to: '17:0',
      })
    } else {
      this.intervals.push({
        from: moment(endTime, 'H:m')
          .set({
            hour: moment(endTime, 'H:m').hour(),
          })
          .format('H:m'),
        to: moment(endTime, 'H:m')
          .set({
            hour: moment(endTime, 'H:m').hour() + 1,
          })
          .format('H:m'),
      })
    }
    const overlapIndexes = this.getOverlappingHours()
    this.overlapIndex = overlapIndexes.length
    console.log('overlapIndexes', overlapIndexes)
  }

  getOverlappingHours() {
    const overlaps = [] as number[]

    if (this.intervals.length <= 1) {
      return overlaps
    }

    for (let i = 0; i < this.intervals.length - 1; i++) {
      for (let j = i + 1; j < this.intervals.length; j++) {
        const startTime1 = moment(this.intervals[i].from, 'H:mm')
        const endTime1 = moment(this.intervals[i].to, 'H:mm')
        const startTime2 = moment(this.intervals[j].from, 'H:mm')
        const endTime2 = moment(this.intervals[j].to, 'H:mm')

        if (
          startTime1.isBetween(startTime2, endTime2) ||
          endTime1.isBetween(startTime2, endTime2) ||
          startTime2.isBetween(startTime1, endTime1) ||
          endTime2.isBetween(startTime1, endTime1)
        ) {
          overlaps.push(i)
          overlaps.push(j)
        }
      }
    }

    return [...new Set(overlaps)]
  }
  hasOverlapIndex(hourIndex: number) {
    const overlapIndexes = this.getOverlappingHours()
    return Math.max(...overlapIndexes) === hourIndex
  }

  is24HourSelected() {
    return this.intervals.length === 1
      ? this.intervals[0].from === '0:0' && this.intervals[0].to === '0:0'
      : false
  }

  toJSON(): any {
    return {
      day: this.day?.toLowerCase(),
      type: this.type,
      date: this.date,
      intervals:
        this.type === 'date' || this.intervals.length > 0
          ? this.intervals || []
          : null,
    }
  }
}
